// extracted by css-extract-rspack-plugin
export default {"tooltipContainer":"tooltipContainer-cFolcZ"};